import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeafletCircleComponent } from './leaflet-circle.component';

@NgModule({
  declarations: [LeafletCircleComponent],
	exports: [LeafletCircleComponent],
  imports: [
    CommonModule
  ]
})
export class LeafletCircleModule { }
